import React from "react";

const logo = "/img/logo.png";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <img alt="My deserve" className="logo-nav-bar" src={logo}/>
    <p>
      <a>
      My deserve @ {new Date().getFullYear()}
      </a>
    </p>
  </footer>
);

export default Footer;
